import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WorkdayReportService } from "../../workday-report.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { CollaboratorsService } from "app/modules/collaborators/collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-workday-users-reports-list",
  templateUrl: "./workday-users-reports-list.component.html",
  styleUrls: ["./workday-users-reports-list.component.scss"],
})
export class WorkdayUsersReportsListComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public contentHeader: IContentHeader;
  public reportsList: any = [];
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public categories: any = [];
  public selectedMonth: string = moment().format("M");
  public selectedYear: string = moment().format("YYYY");
  public statuses_labels: any;
  public searchStatus: number = 10;
  public availableMonths: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: any = [];
  public usersList: any = [];
  public unlockNote: string = "";
  public selectedReport: any;
  public me: ICurrentUser;
  public reports: any = [];
  public available_working_days: Array<number> = [];
  public collaboratorList: any = [];
  public lastDayOfTheSelectedMonth: any = null;
  public totalWorkedHourMonthSelected: number = 0;
  public searchTypeUser: string = "Dipendente";
  public pageNumber: number = 0;

  constructor(
    public _workdayReportService: WorkdayReportService,
    public _utilService: UtilsService,
    public _userService: UserService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.WORKDAY_USERS_REPORTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.WORKDAY_USERS_REPORTS",
            isLink: false,
          },
        ],
      },
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const status = params.status;
      const user = params.user;
      const month = params.month;
      const year = params.year;
      const page = params.page;

      if (!!searchKey && searchKey != 0) {
        this.searchKeyword = searchKey;
      }
      if (!!status && Number(status) >= 0 && Number(status) < 5) {
        this.searchStatus = Number(status);
      }
      if (!!user && user != 0) {
        this.searchTypeUser = user;
      }
      if (!!month && Number(month) > 0 && Number(month) <= 12) {
        this.selectedMonth = month;
      }
      if (!!year && Number(year) > 0) {
        this.selectedYear = year;
      }
      if (!!page) {
        this.pageNumber = page;
      }
    });

    const currentYear = moment().format("YYYY");
    for (let i = 2022; i <= Number(currentYear); i++) {
      this.availableYears.push(String(i));
    }
    this.available_working_days = this._utilService.themeConfiguration.working_days; // Parametro gestito da configurazione per i giorni lavorativi
  }

  async ngOnInit() {
    this.me = await this._authenticationService.getCurrentUser();
    this.statuses_labels = await this._utilService.translate("STATUS");
    await this.loadData();
  }

  updateTableLimit(event) {
    this.tableLimit = Number(event.target.value);
  }

  async loadData() {
    this.collaboratorList = await this._collaboratorService.getCollaboratorList();
    this.reportsList = await this._workdayReportService.getList();

    const approved: string = await this._utilService.translate("APPROVED");
    const saved: string = await this._utilService.translate("STATUS.SAVED");
    const notApproved: string = await this._utilService.translate("REJECTED");
    const pending: string = await this._utilService.translate("PENDING");

    this.reportsList.map((item: any) => {
      if (item.status === 2) {
        item.enabled_label = approved;
      } else if (item.status === 3) {
        item.enabled_label = notApproved;
      } else if (item.status === 0) {
        item.enabled_label = saved;
      } else if (item.status === 1) {
        item.enabled_label = pending;
      }
      item.worked_hours = Number(item.worked_hours);
      item.extra_hours = Number(item.extra_hours);
    });

    const countPending: number = this.reportsList.filter((reportItem: any) => reportItem.status == 1 && reportItem.month == this.selectedMonth).length;
    if (countPending > 0 && window.location.search.length < 1) {
      this.searchStatus = 1;
    }

    await this.reportsFilterList();

    this._utilService.hideLoading();
  }

  async loadReports() {
    this.usersList = await this._utilService.basic_get(`/user-for-workday-report/${this.selectedMonth}/${this.selectedYear}`);
    this.usersList.map((item: any) => {
      item.reports = this.reportsList.filter((report: any) => report.user_hash == item.hash);
    });
  }

  async reportsFilterList(reloadReports: boolean = true) {
    if (reloadReports) {
      await this.loadReports();
    }
    //Resetto la variabile
    this.totalWorkedHourMonthSelected = 0;
    let items: any = this.usersList.sort((a: any, b: any) => (a.lastname > b.lastname ? 1 : -1));
    //Calcolo riferimento delle ore lavorative dell'anno e mese selezionati
    this.lastDayOfTheSelectedMonth = moment(`${this.selectedYear}-${this.selectedMonth.padStart(2, "0")}-01T22:00:00.000Z`, "YYYY-MM-DD")
      .endOf("month")
      .format("DD");
    for (let i = 1; i <= this.lastDayOfTheSelectedMonth; i++) {
      const currentDate = moment(`${this.selectedYear}-${this.selectedMonth.padStart(2, "0")}-${i}T22:00:00.000Z`, "YYYY-MM-D");
      let workingHours: number = this.available_working_days.includes(Number(currentDate.format("d"))) ? 8 : 0;
      this.totalWorkedHourMonthSelected += this._utilService.isHoliday(currentDate) ? 0 : workingHours;
    }
    items.map((user: any) => {
      if (user.reports && user.reports.length > 0) {
        user.currentReport = user.reports.filter((report: any) => report.month == Number(this.selectedMonth) && report.year == Number(this.selectedYear));
      }
      if ((user.currentReport && user.currentReport.length < 1) || (user.reports && user.reports.length < 1)) {
        user.currentReport = [
          {
            status: 4,
            worked_hours: 0,
            extra_hours: 0,
          },
        ];
      }
    });

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.complete_name.toLowerCase().includes(keywords) || item?.business_name?.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 5) {
      items = items.filter((item: any) => item.currentReport[0].status === Number(this.searchStatus));
    }

    if (this.searchTypeUser !== "all") {
      if (this.searchTypeUser === "Collaboratore") {
        items = items.filter((item: any) => item?.role === this.searchTypeUser);
      } else {
        items = items.filter((item: any) => !item.role || item.role !== "Collaboratore");
      }
    }

    items = items.map((item: any) => ({...item, status: item.currentReport[0].status}))

    this.reports = items;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKeyword && this.searchKeyword.length >= 3) {
      url.searchParams.set("search", String(this.searchKeyword));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.searchStatus && this.searchStatus < 5 && this.searchStatus >= 0) {
      url.searchParams.set("status", String(this.searchStatus));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status");
      history.pushState({}, "", url);
    }

    if (!!this.searchTypeUser && this.searchTypeUser !== "all") {
      url.searchParams.set("user", this.searchTypeUser);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("user");
      history.pushState({}, "", url);
    }

    if (!!this.selectedMonth && Number(this.selectedMonth) > 0 && Number(this.selectedMonth) <= 12) {
      url.searchParams.set("month", this.selectedMonth);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("month");
      history.pushState({}, "", url);
    }

    if (!!this.selectedYear && Number(this.selectedYear) > 0) {
      url.searchParams.set("year", this.selectedYear);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("year");
      history.pushState({}, "", url);
    }
  }

  formatLabel(month: number | string) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", Number(month) - 1);
    return date.format("MMMM");
  }

  modalClose() {
    this._modalService.dismissAll();
    this.unlockNote = "";
    this.callbackFn.emit();
  }

  async unlock(selectedReport: any, modal) {
    if (!this._authenticationService.hasCapability("edit_workday_report_status")) {
      window.history.back();
      return false;
    }
    this.selectedReport = selectedReport;

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_UNLOCK_WORKDAY_REPORT");
    deleteText += this.selectedReport.complete_name += ".";
    deleteText += await this._utilService.translate("ALERT.CONFIRM_UNLOCK_WORKDAY_REPORT_CONTINUE");
    await this._utilService.showSWALDeleteConfirmation({ text: deleteText, confirmButtonText: "CONFIRM_UNLOCK" }).then(async (result) => {
      if (result.value) {
        this._modalService.open(modal, {
          centered: true,
          size: "sm",
          backdrop: false,
          keyboard: false,
        });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TITLE_EDIT",
        });
      }
    });
  }

  async sendData() {
    if (!this._authenticationService.hasCapability("edit_workday_report_status")) {
      window.history.back();
      return false;
    }
    this._utilService.showLoading();
    const curReport: any = this.selectedReport;
    await this._workdayReportService
      .updateStatus("reject", {
        report_id: curReport.currentReport[0].id,
        status_note: this.unlockNote,
      })
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UNLOCK_WORKDAY_REPORT" }).then(async () => {
          this._modalService.dismissAll();
          await this.loadData();
        });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALError({ text: "ERROR_REJECT_WORKDAY_REPORT" });
      });
    this.modalClose();
  }

  async exportReportExcel() {
    const startOfMonth: string = `${this.selectedYear}-${String(this.selectedMonth).padStart(2, "0")}-01`;
    //prendo l'ultimo giorno del mese e lo trasformo a numero
    const endOfMonth = Number(moment(startOfMonth).clone().endOf("month").format("DD"));
    //prendo il mese
    const month = moment(startOfMonth).format("MMMM YYYY");
    //prendo il report con stato 2
    let reports = await this._workdayReportService.getExportList(this.selectedMonth, this.selectedYear)
    reports = reports.sort((a, b) => (a?.lastname > b?.lastname ? 1 : -1))

    // mi salvo in una variabile tutto l' array che stamperò all'interno del file
    const row: any[][] = [
      ["FILE PRESENZE MENSILE", "", "", ""],
      ["", "", "", ""],
      ["DATI ELABORAZIONE", "", "GIORNO -->", ""],
      ["CODICE DITTA", "MESE PRESENZE", "CODICE RILEVAZIONE PRESENZE", "COGNOME NOME"],
    ];

    // creazione delle prime due righe dell' excel
    for (let i = 1; i <= endOfMonth * 4; i++) {
      row[0].push("");
      row[1].push("");
    }

    // aggiungiamo le intestazioni delle colonne
    for (let i = 1; i <= endOfMonth; i++) {
      row[2].push(String(i).padStart(2, "0"));
      row[3].push("Causale");

      row[2].push("");
      row[3].push("Ore causale");

      row[2].push("");
      row[3].push("Ore effettive lavorate");

      row[2].push("");
      row[3].push("Giorno lavorativo");
    }

    // recuperiamo l' array dei giorni lavorativi
    const workingDays: number[] = this._utilService.themeConfiguration.working_days;

    // aggiungiamo i dati dei dipendenti
    for (let user of reports) {
      let arr: any[] = ["29", month, user.badge_number, user.lastname + " " + user.firstname];

      if (user.type_code === "occasional" || user.type_code === "stage") {
        for (let i = 0; i < Object.keys(user.report).length; i++) {
          arr.push("");
          arr.push("");
          arr.push("");
          arr.push("");
        }
      } else {
        const data: any = user.report.sort((a: any, b: any) => {
          a = moment(a.date, "YYYY-M-DD");
          b = moment(b.date, "YYYY-M-DD");
          return a > b ? 1 : a < b ? -1 : 0;
        });

        for (const report of data) {
          const date: string = report.date;
          const objDate: any = moment(date, "YYYY-M-DD");

          const isWorkingDay: boolean = workingDays.includes(Number(objDate.format("d")));

          // gestiamo il valore del giorno lavorativo
          if (this._utilService.isHoliday(objDate)) {
            arr.push("F1");
            arr.push("8");
            arr.push("0");
            arr.push("2");
          }
          // se non è un giorno lavorativo imposto il giorno lavorativo a uno (non lavorativo)
          else if (!isWorkingDay) {
            let oreEffettive: number = 0;

            // se ci sono extra per le commesse li dobbiamo aggiungere
            for (const commission of report.commissions) {
              oreEffettive += commission.extra.hours_payroll || 0;
            }

            // se ci sono extra per i costi di struttura li dobbiamo aggiungere
            for (const structure of report.structures) {
              oreEffettive += structure.extra.hours_payroll || 0;
            }

            arr.push("");
            arr.push("");
            arr.push(String(oreEffettive));
            arr.push("");
          } else {
            let causale: string = "";
            let oreCausale: number = 0;
            let oreEffettive: number = report.working_hours; // aggiungo le ore lavorate
            let giornoLavorativo: string = "0"; // 0 lavorativo - 1 non lavorativo - 2 festivo

            // se ci sono assenze le aggiungiamo solo nei giorni lavorativi, per i giorni non lavorativi lo aggiungiamo solo se è una malattia
            if (report.absences.length > 0) {
              for (let absence of report.absences) {
                if (isWorkingDay) {
                  // se il codice causale non è già presente lo inseriamo
                  causale += causale.includes(absence.code) ? "" : `${absence.code} `;
                  oreCausale += Number(absence.hours);
                  giornoLavorativo = Number(absence.hours) > 7 ? "1" : giornoLavorativo;
                } else {
                  if (absence.category === "malattia") {
                    causale += `${absence.code} `;
                    oreCausale += Number(absence.hours);
                    giornoLavorativo = "1";
                  }
                }
              }
              causale = causale.trim();
            }

            // controllo se il giorno è festivo oppure se non è un giorno lavorativo
            if (this._utilService.isHoliday(objDate.format("YYYY-MM-DD"))) {
              giornoLavorativo = "2";
            }

            // se ci sono extra per le commesse li dobbiamo aggiungere
            for (const commission of report.commissions) {
              oreEffettive += commission.extra.hours_payroll || 0;
            }

            // se ci sono extra per i costi di struttura li dobbiamo aggiungere
            for (const structure of report.structures) {
              oreEffettive += structure.extra.hours_payroll || 0;
            }

            // push dentro arr
            arr.push(causale);
            arr.push(Number(oreCausale));
            arr.push(Number(oreEffettive));
            arr.push(giornoLavorativo);
          }
        }
      }

      row.push(arr);
    }
    const fileName = `export rapportini ore mensili di ${month}_${moment().format("DD-MM-YYYY")}.xlsx`;
    if (row.length < 1) return false;
    // creo una nuova pagina
    const workbook = XLSX.utils.book_new();
    // creo il contenuto della pagina passandogli l' array
    const worksheet = XLSX.utils.aoa_to_sheet(row);

    // setto la larghezza delle colonne
    worksheet["!cols"] = row[3].map((key) => {
      return { width: key.length + 6 }; // plus 2 to account for short object keys
    });
    // aggiungo il contenuto alla pagina e do il nome alla pagina
    XLSX.utils.book_append_sheet(workbook, worksheet, "Input presenze");
    // prendo il nome del file e gli aggiungo il formato salva il file Excel
    XLSX.writeFile(workbook, fileName);
  }

  async exportReportPDF(report_id: number) {
    this._utilService.showLoading();

    const report: any = await this._workdayReportService.get(report_id);

    // creo il nome con cui si salverà il file
    const fileName = report.complete_name + "-" + this.selectedMonth + "-" + this.selectedYear + ".pdf";

    const month: string = moment(this.selectedYear + "-" + this.selectedMonth.padStart(2, "0") + "-01").format("MMMM YYYY");

    // stampo il file
    let body: string =
      '<body style="margin: 0; padding: 0; box-sizing: border-box;">' +
      // stampo il nome e il mese
      '<div style="height: 35px;width: 420px; font-size: 12px; display: flex; margin-top:10px;">' +
      '<div style="width:100px">' +
      `<img src="${environment.CDN_URL}/site/templates/logo-nepta-header.png" alt="nepta" style="width: 100%">` +
      "</div>" +
      '<div style="margin-left: 20px; display: flex; flex-direction: column; line-height: 15px">' +
      '<span style="text-transform: capitalize; letter-spacing: normal; word-spacing: -.7ch">' +
      report.complete_name +
      "</span>" +
      '<span style="letter-spacing: normal; text-transform: capitalize; word-spacing: -.7ch;"> ' +
      month +
      "</span>" +
      "</div>" +
      "</div>" +
      // inizio della tabella
      '<div style="width:610px; height:60px; margin-top:20px; font-size:11px;display: flex; border-left:0.2px solid #cccccc;">';
    // inizializzo il mio contatore
    let i: number = 0;

    // variabile somma ore
    let sumWorkingHours: number = 0;

    const daysReport: any[] = Object.values(report.data).sort((a: any, b: any) => {
      a = moment(a.date, "YYYY-M-DD");
      b = moment(b.date, "YYYY-M-DD");
      return a > b ? 1 : a < b ? -1 : 0;
    });

    for (const data of daysReport) {
      let workedHours: number = data.working_hours;
      // se ci sono extra per le commesse li dobbiamo aggiungere
      for (const commission of data.commissions) {
        workedHours += commission.extra.hours_payroll || 0;
        workedHours += commission.extra.extra_km || 0;
      }
      // se ci sono extra per i costi di struttura li dobbiamo aggiungere
      for (const structure of data.structures) {
        workedHours += structure.extra.hours_payroll || 0;
        workedHours += structure.extra.extra_km || 0;
      }
      // capisco che giorno mi restituisce e ciclo
      let day = moment(data.date, "YYYY-M-D");
      body +=
        //stamperò la colonna contenente numero, giorno, festività, ora lavorata
        '<div style="text-align: center;width: ' +
        100 / daysReport.length +
        "%; height:100%; border-top: 0.2px solid #cccccc; border-right: 0.2px solid #cccccc; border-bottom: 0.2px solid #cccccc; display: flex;" +
        " flex-direction: column;" +
        " background-color:" +
        (day.day() == 6 || day.day() == 0 ? "#f3f3f3" : this._utilService.isHoliday(day.format("YYYY-MM-DD")) ? "#dcdcdc" : "#fff") +
        '">' +
        // numero giorno
        '<span style="width: 100%;height: 20px;letter-spacing: normal; margin: auto; border-bottom: 0.2px solid #cccccc">' +
        String(i + 1).padStart(2, "0") +
        "</span>" +
        // nome giorno
        '<span style="width: 100%;height: 20px;letter-spacing: normal; margin: auto; padding-top: 1px">' +
        (this._utilService.isHoliday(day.format("YYYY-MM-DD")) ? "-" : this._utilService.formatDate(day, "dd")) +
        "</span>" +
        // ore lavorate
        '<span style="width: 100%;height: 20px;margin: auto; border-top: 0.2px solid #cccccc">' +
        workedHours +
        "</span>" +
        "</div>";
      i++;
      sumWorkingHours += workedHours;
    }

    body +=
      "</div>" +
      '<div style="font-size: 10px; width:610px;margin: 10px 0 190px 0">' +
      '<span style="letter-spacing: normal; word-spacing: -.4ch;">Totale ore ' +
      sumWorkingHours +
      "</span>" +
      "</div>" +
      `<img src="${environment.CDN_URL}/site/templates/footer-documento.png" alt="nepta" style="width:610px;margin:0 auto;">` +
      "</body>";

    // genero l'oggetto contenete l'orientamento, l'unità di misura, e il formato'
    const doc = new jsPDF("l", "px", "a4");
    // faccio sparire il loading
    doc.html(body, {
      callback:  (docReturn) =>{
        // salvo il pdf
        docReturn.save(fileName);
        setTimeout(async () => {
          this._utilService.hideLoading();
          await this._utilService.showToastrSuccess("WORKDAY_REPORT_DOWNLOADED")
        }, )
      },
      x: 10,
      y: 10,
    });
  }

  async approveReport(report: any) {
    if (!this._authenticationService.hasCapability("edit_workday_report_status")) {
      window.history.back();
      return false;
    }
    const data: any = {
      report_id: report.currentReport[0].id,
    };
    this._utilService.showLoading();
    await this._workdayReportService
      .updateStatus("approve", data)
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVED_WORKDAY_REPORT" }).then(async (result) => {
          if (result.value) {
            await this.loadData();
            return false;
          }
        });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_APPROVED_WORKDAY_REPORT" });
      });
  }

  setPage(pageInfo: any) {
    this.pageNumber = pageInfo.offset;
    const url = new URL(window.location.href);

    if (!!this.pageNumber && this.pageNumber >= 1) {
      url.searchParams.set("page", String(this.pageNumber));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("page");
      history.pushState({}, "", url);
    }
  }

  async generateReport(row: any) {
    await this._utilService
      .showSWALDeleteConfirmation({
        text: "ALERT.CONFIRM_GENERATE_WORKDAY_REPORT",
        confirmButtonText: "BTN_SUCCESS",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      })
      .then(async (result: any) => {
        if (result.value) {
          this._utilService.showLoading();
          return this._utilService
            .basic_get(`/report/generate/${this.selectedMonth}/${this.selectedYear}/${row.hash}`)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadData();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_WORKDAY_REPORT" });
            })
            .catch(async (err: any) => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_GENERATE_WORKDAY_REPORT" });
              console.error(err);
            });
        }
      });
  }

  canApprove(report: any) {
    return (
      report.currentReport &&
      report.currentReport.length > 0 &&
      report.currentReport[0].status === 1 &&
      report.currentReport[0].worked_hours === this.totalWorkedHourMonthSelected &&
      report.currentReport[0].extra_hours === 0
    );
  }

  canUnlock(report: any) {
    return report.currentReport && report.currentReport.length > 0 && report.currentReport[0].status == 2 && report.currentReport[0].user_hash !== this.me.hash;
  }

  canGenerate(report: any) {
    return report.currentReport[0].status !== 2 && report.currentReport[0].user_hash !== this.me.hash;
  }
}
